// One small WebP per pet form instead of the whole five-form sheet (2026-10-01).
// scripts/build-pet-evolution-forms.py crops each form to its clip path's bounding box at full
// sheet resolution; the page draws the crop at those same sheet coordinates, so the clip
// data's viewBox and clip path apply unchanged. Keep formBox() in step with that script.
export const PET_FORMS_DIR = "/assets/pet-evolution/v2/forms";

export const petFormUrl = (species: string, formIndex: number) => `${PET_FORMS_DIR}/${species}-${formIndex}.webp`;

/** [x, y, width, height] of the form's crop in sheet coordinates. */
export function formBox(clipPath: string, sheetWidth: number, sheetHeight: number): [number, number, number, number] {
  const numbers = (clipPath.match(/\d+/g) ?? []).map(Number);
  const xs = numbers.filter((_, index) => index % 2 === 0);
  const ys = numbers.filter((_, index) => index % 2 === 1);
  const left = Math.max(0, Math.min(...xs)), top = Math.max(0, Math.min(...ys));
  const right = Math.min(sheetWidth, Math.max(...xs)), bottom = Math.min(sheetHeight, Math.max(...ys));
  return [left, top, right - left, bottom - top];
}

/** Forms this page has already downloaded; a pet that changes form keeps its old look until the new file is in. */
export const loadedPetForms = new Set<string>();
export function loadPetForm(url: string): Promise<void> {
  if (loadedPetForms.has(url)) return Promise.resolve();
  return new Promise((done) => {
    const image = new Image();
    image.onload = image.onerror = () => { loadedPetForms.add(url); done(); };
    image.src = url;
  });
}
